import { Mail, ListOrdered, ShieldAlert, FileQuestion, Inbox } from "lucide-react";
import { Reveal } from "./Reveal";

const faqs = [
    {
        icon: Mail,
        q: "Cosa ricevo dopo l'acquisto?",
        a: "Un PDF digitale contenente le 3 simulazioni e il relativo materiale di correzione e ripasso.",
    },
    {
        icon: ListOrdered,
        q: "Quante domande contiene?",
        a: "120 quesiti complessivi, suddivisi in 3 simulazioni da 40 quesiti.",
    },
    {
        icon: ShieldAlert,
        q: "È materiale ufficiale del Ministero della Difesa?",
        a: "No. È materiale didattico indipendente creato per esercitarsi. Non è prodotto, approvato o affiliato al Ministero della Difesa.",
    },
    {
        icon: FileQuestion,
        q: "Le domande saranno quelle presenti all'esame?",
        a: "No. I quesiti sono originali e realizzati esclusivamente per esercitazione. Non viene garantita la presenza di quesiti identici o analoghi nella prova ufficiale.",
    },
    {
        icon: Inbox,
        q: "Come ricevo il prodotto?",
        a: "Dopo il pagamento è subito disponibile il download del PDF e ricevi anche un'email con il link per scaricarlo.",
    },
];

export const Faq = () => (
    <section id="faq" className="relative bg-slate-50 py-20 sm:py-28">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <Reveal>
                <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy-950 sm:text-4xl">
                    Domande frequenti
                </h2>
            </Reveal>
            <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
                {faqs.map((f, i) => (
                    <Reveal key={i} delay={i * 0.07}>
                        <div
                            data-testid={`faq-accordion-item-${i}`}
                            className="h-full rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-gold/60"
                        >
                            <f.icon className="h-6 w-6 text-navy-950" />
                            <h3 className="mt-4 text-sm font-bold leading-snug text-navy-950">{f.q}</h3>
                            <p className="mt-2 text-xs leading-relaxed text-slate-500">{f.a}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
